import React from "react";

import SlidingPost from "./SlidingPost.jsx";

import useWallsPosts from "./../hooks/WallsPosts.jsx";

const App = ({
  accessToken,
  displayDuration,
  refreshInterval,
  limit,
  types,
  maxPostCommentLength,
}) => {
  const { post } = useWallsPosts({
    accessToken,
    ...(displayDuration && { displayDuration: Number(displayDuration) }),
    ...(refreshInterval && { refreshInterval: Number(refreshInterval) }),
    ...(limit && { limit: Number(limit) }),
    ...(types && { types }),
  });

  return (
    <div>
      <SlidingPost post={post} maxPostCommentLength={maxPostCommentLength} />
    </div>
  );
};

export default App;
